export default "__VITE_ASSET__3bf194ef__"